import { Injectable, OnDestroy } from "@angular/core";
import { Subject, combineLatest } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserSessionService } from "../user-session/user-session.service";
import { EventsService } from "../event/event.service";
import { LobbyApiService } from "./lobby.api.service";

@Injectable({
  providedIn: "root",
})
export class GamesService implements OnDestroy {
  private userStatus: any;
  public favouriteGames: any[];
  public recentGames: any[];
  public allGames: any[];
  public primaryGames: any[];
  public lobbyName: any;
  public favouriteGameStore: any;
  private userLobbySubcriber: any;

  _games: Subject<any> = new Subject();
  _lobbyName: Subject<any> = new Subject();
  _destroy: Subject<any> = new Subject();

  constructor(
    private userService: UserSessionService,
    private lobbyApiService: LobbyApiService,
    private events: EventsService
  ) {
    this.userLobbySubcriber = combineLatest([
      this.userService.getUserStatus(),
      this._lobbyName,
    ]).pipe(takeUntil(this._destroy)).subscribe(([userStatus, lobbyName]) => {
      if (userStatus && lobbyName) {
        this.updateUserStatus(userStatus);
      } else {
        if (!userStatus) {
          this.resetOnLogout();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.userLobbySubcriber) this.userLobbySubcriber.unsubscribe();
    this._destroy.next();
    this._destroy.complete();
  }

  isFavourite(game_id) {
    if (!this.favouriteGames) return false;
    return game_id in this.favouriteGameStore;
  }

  getGames() {
    return this._games;
  }

  setGames(allGames) {
    this._games.next(allGames);
    this.events.publish('event:checkRecent:Fav:games')
  }
  
  getGameById(id: number) {
    return this.allGames.find((game) => game.id == id);
  }
  
  updateUserStatus(userStatus) {
    this.userStatus = userStatus;
  }

  setLobbyName(lobbyName) {
    this.lobbyName = lobbyName;
    this._lobbyName.next(this.lobbyName);
  }

  combineAndEmit(games, favorite = this.favouriteGames) {
    if (this.recentGames) games["Recent Games"] = this.recentGames;
    games["Favorites"] = favorite;
    this.allGames = games;
    this.setGames(this.allGames);
  }

  createFavouriteStore(payload) {
    this.favouriteGameStore = {};
    payload.forEach((game) => {
      this.favouriteGameStore[game.id] = "1";
    });
  }

  async getAllGames() {
    if (this.userStatus == null) return;
    let result = await Promise.resolve(this.fetchGames());
    this.primaryGames = result?.payload;
    result = await Promise.resolve(this.getFavourites());
    this.createFavouriteStore(result.payload);
    this.favouriteGames = result.payload;
    await this.getRecentGames();
    if (!this.primaryGames["Favorites"]) this.combineAndEmit(this.primaryGames);
  }

  fetchGames() {
    return this.lobbyApiService.fetchGamesByLobbyName(this.lobbyName)
      .toPromise();
  }

  getFavourites() {
    return this.lobbyApiService.getFavourites().toPromise();
  }

  addFavourites(game_id) {
    return this.lobbyApiService.addFavourites(game_id).toPromise();
  }
  async removeFavouritesAndRecreate(game_id) {
    const response = await this.removeFavourites(game_id);
    if (response.result) {
      this.favouriteGames = response.payload;
      this.createFavouriteStore(response.payload);
      this.combineAndEmit(this.primaryGames);
    } else {
      console.log("Error removing Fav Games", response);
    }
  }
  async addFavouritesAndRecreate(gamedata) {
    const response = await this.addFavourites(gamedata.id);
    if (response.result) {
      this.favouriteGames = response.payload;
      this.createFavouriteStore(response.payload);
      this.combineAndEmit(this.primaryGames);
    } else {
      console.log("Error adding Fav Games", response);
    }
  }
  removeFavourites(game_id) {
    return this.lobbyApiService.removeFavourites(game_id).toPromise();
  }

  removeRecentAndRecreate(game_id) {
    this.recentGames = this.recentGames.filter((game) => game.id != game_id);
  }

  resetOnLogout() {
    this.updateUserStatus(null);
    if (this.primaryGames && this.primaryGames["Favorites"]) {
      this.combineAndEmit(this.primaryGames, []);
    }
  }

  getRecentGames(){

  }
}
